import { render } from "./Footer.vue?vue&type=template&id=9fa8703a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=9fa8703a&lang=scss&scoped=true"

import exportComponent from "E:\\_projekte\\PRIGNITZMUSEUM_HAVELBERG\\ARCHITEKTURSPUR\\release\\architekturspur\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa8703a"]])

export default __exports__